/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-31 16:06:43
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-01 09:38:27
 */
/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:55:36
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:15:38
 */
import req from "@/utils/request";

export const list = (params) => req.post("/wrokflow-service/m/workflow/procdef/list", params);
export const add = (params) => req.post("/wrokflow-service/m/workflow/procdef/add", params);
export const update = (params) => req.post("/wrokflow-service/m/workflow/procdef/update", params);
export const del = (params) => req.post("/wrokflow-service/m/workflow/procdef/del", params);
export const details = (params) => req.post("/wrokflow-service/m/workflow/procdefDesign/details", params);
export const listTwo = (params) => req.post("/manager-service/m/management/list", params);
export const save = (params) => req.post("/wrokflow-service/m/workflow/procdefDesign/save", params);
export const listRoles = (params) => req.post("/manager-service/m/role/list", params);
export const runningRecord = (params) => req.post("/wrokflow-service/m/workflow/runningRecord", params);
export const runningRecordInfo = (params) => req.post("/wrokflow-service/m/workflow/runningRecordInfo", params);

